import Input from './Input'

const InputMobile = (props) => {
  return <Input {...props} pattern="xxx-xxx-xxxx" isNumber={true} />
}

export default InputMobile
